const AccumulationType = {
    race: 0,
    overall: 1
};

export default AccumulationType;